import { Component, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { FlatTreeControl } from '@angular/cdk/tree';
import { TreeService } from 'src/app/services/Tree/tree.service';
import { MediaFolder, MediaTree, FolderDialogData, ConfirmDialogData, Error, RenameFolderDialogData, FolderMoveResultData, FolderNode, SelectFolderData } from 'src/app/utils/common-classes';
import { UtilsService } from 'src/app/services/Utils/utils.service';
import { MatDialog, MatDialogRef, MatMenuTrigger } from '@angular/material';
import { CreateFolderDialogComponent } from '../create-folder-dialog/create-folder-dialog.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { RenameFolderDialogComponent } from '../rename-folder-dialog/rename-folder-dialog.component';
import { FolderDataSource } from 'src/app/utils/dynamic-tree-classes';
import { MoveFolderDialogComponent } from '../move-folder-dialog/move-folder-dialog.component';
import { FolderService } from 'src/app/services/Folder/folder.service';

@Component({
  selector: 'app-folder-tree',
  templateUrl: './folder-tree.component.html',
  styleUrls: ['./folder-tree.component.scss']
})
export class FolderTreeComponent implements OnInit {
  @ViewChild('folderMenuTrigger', { static: true, read: MatMenuTrigger })
  folderMenuTrigger: MatMenuTrigger;

  @ViewChild('treeMenuTrigger', { static: true, read: MatMenuTrigger })
  treeMenuTrigger: any;

  @Input()
  mediaTree: MediaTree;

  @Output()
  selectFolder = new EventEmitter<SelectFolderData>();

  public treeControl: FlatTreeControl<FolderNode>;
  public dataSource: FolderDataSource;
  public contextMenuPosition = { x: '0px', y: '0px' };
  public selectedFolder: FolderNode;

  constructor(private treeService: TreeService,
    public utils: UtilsService,
    private dialog: MatDialog,
    private folderService: FolderService) {

  }

  onContextMenu(event: MouseEvent, node: FolderNode): void {
    event.preventDefault();
    this.contextMenuPosition.x = event.clientX + 'px';
    this.contextMenuPosition.y = event.clientY + 'px';
    if (node) {
      this.folderMenuTrigger.menuData = { 'node': node };
      this.folderMenuTrigger.menu.focusFirstItem('mouse');
      this.folderMenuTrigger.openMenu();
    } else {
      this.treeMenuTrigger.menu.focusFirstItem('mouse');
      this.treeMenuTrigger.openMenu();
    }
  }

  ngOnInit() {
    this.treeControl = new FlatTreeControl<FolderNode>(this.getLevel, this.isExpandable);
    this.dataSource = new FolderDataSource(this.treeControl, this.mediaTree.mediaTreeId, this.utils, this.folderService);
  }

  private getLevel(node: FolderNode): number {
    return node.level;
  };

  private isExpandable(node: FolderNode): boolean {
    return node.expandable;
  };

  public hasChild(_: number, _nodeData: FolderNode): boolean {
    return _nodeData.expandable;
  };

  public folderClick(node: FolderNode): void {
    let _self = this;
    let data: SelectFolderData = new SelectFolderData();
    data.node = node;
    data.tree = _self.mediaTree
    _self.selectFolder.emit(data);
  }

  public folderSelected(node: FolderNode): void {
    let _self = this;
    let folder: FolderNode = _self.dataSource.getFolder(node.mediaFolderId);
    this.selectedFolder = folder;
  }

  public createFolder(node: FolderNode, mediaTree: MediaTree): void {
    let _self = this;
    let data: FolderDialogData = { node: node, mediaTree: mediaTree };
    let dialogRef: MatDialogRef<CreateFolderDialogComponent> = _self.dialog.open(CreateFolderDialogComponent, { width: "400px", data: data, disableClose: true });
    dialogRef.afterClosed().subscribe((newFolder: MediaFolder) => {
      if (newFolder) {
        if (!node || _self.treeControl.isExpanded(node)) {
          _self.dataSource.addFolder(newFolder, node);
        } else {
          _self.treeControl.expand(node);
        }
      }
    });
  }

  public async deleteFolder(node: FolderNode) {
    let _self = this;
    let title: string = await _self.utils.translateKey("dialog.confirm.title.delete-folder");
    let message: string = await _self.utils.translateKeyWithData("dialog.confirm.message.delete-folder", { folderName: node.getName(_self.utils.getLanguage()) });
    let data: ConfirmDialogData = { title: title, message: message };
    let dialogRef: MatDialogRef<ConfirmDialogComponent> = _self.dialog.open(ConfirmDialogComponent, { width: "400px", data: data, disableClose: true });
    dialogRef.afterClosed().subscribe((del: boolean) => {
      if (del) {
        _self.utils.showShortLoader
        _self.folderService.deleteFolder(node.mediaFolderId).then(() => {
          _self.dataSource.deleteFolder(node);
        }).catch((err) => {
          return _self.utils.getErrorShowToast(err);
        }).finally(() => {
          _self.utils.hideShortLoader();
        });
      }
    });
  }

  public renameFolder(node: FolderNode): void {
    let _self = this;
    let data: RenameFolderDialogData = { node: node };
    let dialogRef: MatDialogRef<RenameFolderDialogComponent> = _self.dialog.open(RenameFolderDialogComponent, { width: "600px", data: data, disableClose: true, panelClass: "no-padding-dialog-container", autoFocus: false });
    dialogRef.afterClosed().subscribe((renamedFolder: FolderNode) => {
      if (renamedFolder) {
        _self.dataSource.updateFolder(renamedFolder);
      }
    });
  }

  public moveFolder(node: FolderNode, mediaTree: MediaTree): void {
    let _self = this;
    let data: FolderDialogData = { node: node, mediaTree: mediaTree };
    let dialogRef: MatDialogRef<MoveFolderDialogComponent> = _self.dialog.open(MoveFolderDialogComponent, { width: "50%", data: data, minWidth: "500px", height: "600px", disableClose: true });
    dialogRef.afterClosed().subscribe((folderMoveResultData: FolderMoveResultData) => {
      if (folderMoveResultData) {

        //elimino il nodo attuale
        _self.dataSource.deleteFolder(node);

        //aggiungo all' albero
        if (folderMoveResultData.parentFolder) {
          //nuova cartella padre se non null cerco se il padre è presente
          let parentFolder: FolderNode = _self.dataSource.getFolder(folderMoveResultData.parentFolder.mediaFolderId);
          if (parentFolder) {
            //se il padre è attualmente presente nell' albero aggiungo la cartella
            if (_self.treeControl.isExpanded(parentFolder)) {
              //se il padre è già aperto aggiungo
              _self.dataSource.addFolder(folderMoveResultData.folder, parentFolder);
            } else {
              //se il padre è chiuso lo apro
              _self.treeControl.expand(parentFolder);
            }
          }
        } else {
          //nuova cartella padre se null aggiungo alla root
          _self.dataSource.addFolder(folderMoveResultData.folder, null);
        }
      }
    });
  }

}